export const PHI_VISIBILITY_VALUES = [true, false]

export const TIMEZONE = {
  losAngeles: 'America/Los_Angeles',
  newYork: 'America/New_York',
  utc: 'Etc/UTC',
}
